import React from 'react';
import CaseCustomerCard from './CaseCustomerCard';
import CaseDriverProfileCard from './CaseDriverProfileCard';
import CaseMetaControls from './CaseMetaControls';
import CaseLinkedEntityCard from './CaseLinkedEntityCard';
import CaseLinkedBayCard from './CaseLinkedBayCard';

// Left pane: everything that describes the case rather than the conversation —
// who the customer is, the driver's own record, the case's state, and what it
// is attached to.
export default function CaseLeftPane({ data, onDone }) {
  return (
    <div className="space-y-4">
      <CaseCustomerCard caseData={data.case} customer={data.customer} onDone={onDone} />
      <CaseDriverProfileCard
        caseData={data.case}
        profile={data.driverProfile}
        onDone={onDone}
      />
      <CaseMetaControls caseData={data.case} admins={data.admins} onDone={onDone} />
      <CaseLinkedEntityCard
        caseData={data.case}
        linkedBooking={data.linkedBooking}
        linkedOrder={data.linkedOrder}
        onDone={onDone}
      />
      <CaseLinkedBayCard caseData={data.case} rigs={data.rigs} onDone={onDone} />
    </div>
  );
}